import styled, { keyframes } from 'styled-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const revealAnimation = keyframes`
  0% {
    background-color: unset;
  }
  100% {
    background-color: white;
  }
`

export const SettingMenuIcon = styled(FontAwesomeIcon)<{
    isModalOpen: boolean
}>`
    font-size: 2.25em;
    color: ${({ isModalOpen }) =>
        isModalOpen ? 'rgb(0,0,0)' : 'rgba(255,255,255,0.4)'};
    @media (max-width: 767px) {
        position: relative;
        top: 23%;
    }
`

export const SettingButtonWrapper = styled.a<{ isModalOpen: boolean }>`
    font-size: 0.7em;
    height: 3rem;
    width: 3rem;
    margin-left: 1rem;
    background-color: ${({ isModalOpen }) => (isModalOpen ? 'white' : 'none')};
    border-radius: 20px;
    z-index: 999;
    &:hover ${SettingMenuIcon} {
        color: ${({ isModalOpen }) => (isModalOpen ? 'black' : 'white')};
    }

    @media (max-width: 767px) {
        display: block !important;
        position: fixed;
        border-radius: 0;
        margin: 0;
        top: 0px;
        left: 40px;
        height: 48px !important;
    }
    @media (max-width: 1023px) {
        margin-left: 0.5rem;
    }
`
